import { useTranslation } from "react-i18next";
import { Input, Label, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { post } from "../../../../../utils/helpers/api";
import { useState } from "react";

function RejectReasonModal({ open, onClose, onSubmit, quoteData }) {
  const { t } = useTranslation();
  const [reason, setReason] = useState('');

  return(
    <Modal
      isOpen={open}
      toggle={onClose}
      centered
      size="md"
      zIndex={9999}
    >
      <ModalHeader>
        {t('sales.rejectQuote')}
      </ModalHeader>

      <ModalBody>
        <Label>{t('common.reason')}: </Label>
        <Input type="select" value={reason} onChange={(e) => setReason(e.target.value)}>
          <option value="price_too_high">{t('sales.reasonPriceTooHigh')}</option>
          <option value="chose_another_supplier">{t('sales.reasonChoseAnotherSupplier')}</option>
          <option value="budget_constraints">{t('sales.reasonBudgetConstraints')}</option>
          <option value="project_cancelled">{t('sales.reasonProjectCancelled')}</option>
          <option value="project_postponed">{t('sales.reasonProjectPostponed')}</option>
          <option value="requirements_changed">{t('sales.reasonRequirementsChanged')}</option>
          <option value="scope_not_suitable">{t('sales.reasonScopeNotSuitable')}</option>
          <option value="decision_delayed">{t('sales.reasonDecisionDelayed')}</option>
          <option value="no_response">{t('sales.reasonNoResponse')}</option>
          <option value="lost_to_competitor">{t('sales.reasonLostToCompetitor')}</option>
          <option value="timeline_not_suitable">{t('sales.reasonTimelineNotSuitable')}</option>
          <option value="customer_did_not_proceed">{t('sales.reasonCustomerDidNotProceed')}</option>
          <option value="duplicate_opportunity">{t('sales.reasonDuplicateOpportunity')}</option>
          <option value="internal_decision">{t('sales.reasonInternalDecision')}</option>
          <option value="other">{t('common.other')}</option>
        </Input>
      </ModalBody>

      <ModalFooter>
        <button className="btn btn-secondary btn-sm" onClick={onClose}>{t('common.cancel')}</button>
        <button className="btn btn-primary btn-sm" onClick={() => {
          onSubmit(reason);
          onClose();
        }}>{t('common.confirm')}</button>
      </ModalFooter>
    </Modal>
  );
}

export default RejectReasonModal;